import moment from 'moment';

export default {
    props: ['meeting'],
    template: '<div class="alert alert-danger countdown text-center">Class starts in: {{countdown}}</div>',
    data() {
        return {
            countdown: null
        };
    },
    mounted() {
        this.startCountdown();
    },
    computed: {
        countdown: function() {
            return this.countdown;
        }
    },
    methods: {
        startCountdown: function() {

            var now = new Date();
            var startTime = moment(this.meeting.startTime).local();
            
            var duration = moment.duration(startTime.diff(moment(now)));
            var countdown = moment(moment.duration(duration._milliseconds)._data).format("H:mm:ss");
            this.countdown = countdown;
            setTimeout(this.startCountdown, 1000);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/reusable/course-countdown/individual.js